import { createAction, props } from '@ngrx/store';

export const loadUpgradeOffers = createAction(
  '[MMB State] loadUpgradeOffers',
  props<{ recLoc: string; lastName: string }>()
);
